// extracted by mini-css-extract-plugin
export var askAiIcon = "_ma-9";
export var container = "_ma-0";
export var groupSeparator = "_ma-a";
export var highlight = "_ma-4";
export var resultIcon = "_ma-5";
export var resultItem = "_ma-7";
export var resultSubtitle = "_ma-3";
export var resultTitle = "_ma-2";
export var resultsList = "_ma-1";
export var searchGroup = "_ma-6";
export var selected = "_ma-8";